// extracted by mini-css-extract-plugin
export default {"mainButton":"styles_mainButton__n4Nu0","primary":"styles_primary__8SL0O","secondary":"styles_secondary__PJLRM","buttonContainer":"styles_buttonContainer__roqZW"};